import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DashboardLayoutComponent } from "./dashboard-layout/dashboard-layout.component";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from "@angular/router";
import { ContentBodyComponent } from './content-body/content-body.component';
import { ContentHeaderComponent } from './content-header/content-header.component';
import { PanelMenuModule } from "primeng/panelmenu";
import { MenubarModule } from "primeng/menubar";
import { CardModule } from 'primeng/card';
import { PanelModule } from 'primeng/panel';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { MenuModule } from 'primeng/menu';
import { SidebarModule } from 'primeng/sidebar';
import { ButtonModule } from 'primeng/button';
import { TabMenuModule } from 'primeng/tabmenu';
import { HomeHeaderComponent } from './home-header/home-header.component';
import { DividerModule } from 'primeng/divider';
import { UserDashboardComponent } from '../components/user-dashboard/user-dashboard.component';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { ExportOfferDetailComponent } from './export-offer/export-offer-detail/export-offer-detail/export-offer-detail.component';
import { CarouselModule } from 'primeng/carousel';
import { TimerComponent } from './timer/timer.component';
import { WishListComponent } from './wish-list/wish-list.component';
import { CalendarModule } from 'primeng/calendar';
import { SwitchLangComponent } from './switch-lang/switch-lang.component';
import { DropdownModule } from 'primeng/dropdown';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { ImportRequestDetailComponent } from './import-request/import-request-detail/import-request-detail.component';
import { ExportOfferDetailDescriptionComponent } from './export-offer/export-offer-detail/export-offer-detail-description/export-offer-detail-description.component';
import { ExportOfferDetailCarouselComponent } from './export-offer/export-offer-detail/export-offer-detail-carousel/export-offer-detail-carousel.component';
import { ImportOrderDeliveryComponent } from './import-order/import-order-delivery/import-order-delivery.component';
import { ImportOrderOperationComponent } from './import-order/import-order-operation/import-order-operation.component';
import { TableModule } from "primeng/table";
import { UserImportOrderListComponent } from './import-order/user-import-order-list/user-import-order-list.component';
import { FrozenFruitExportOfferDetailComponent } from './frozen-fruit-export-offer/frozen-fruit-export-offer-detail/frozen-fruit-export-offer-detail.component';
import { FrozenFruitExportOfferDetailCarouselComponent } from './frozen-fruit-export-offer/frozen-fruit-export-offer-detail-carousel/frozen-fruit-export-offer-detail-carousel.component';
import { FrozenFruitExportOfferDetailDescriptionComponent } from './frozen-fruit-export-offer/frozen-fruit-export-offer-detail-description/frozen-fruit-export-offer-detail-description.component';
import { InputNumberModule } from "primeng/inputnumber";
import { ExportOfferCreateOptionComponent } from './export-offer/export-offer-create-option/export-offer-create-option.component';
import { DialogModule } from "primeng/dialog";
import { ExportOfferPictureUploaderComponent } from './export-offer/export-offer-picture-uploader/export-offer-picture-uploader.component';
import { FileUploadModule } from "primeng/fileupload";
import { ColorPickerModule } from 'primeng/colorpicker';
import { ExportOfferCertificateTypeComponent } from './export-offer/export-offer-certificate-type/export-offer-certificate-type.component';
import { DataViewLayoutOptions, DataViewModule } from "primeng/dataview";
import { InputMaskModule } from "primeng/inputmask";
import { CountryDescriptionPipe } from '../../pipes/country-description.pipe';
import { DocumentDescriptionPipe } from '../../pipes/document-description.pipe';
import { ColorNamePipe } from "src/app/pipes/color-name.pipe";
import { SpeciesNamePipe } from "src/app/pipes/species-name.pipe";
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { RequestsCodeComponent } from './requests-code/requests-code.component';
import { FormErrorMessagePipe } from "src/app/pipes/form-error-message.pipe";
import { ImportOrderBillInfoComponent } from './import-order/import-order-bill-info/import-order-bill-info.component';
import { ImportOrderLoadingDataComponent } from './import-order/import-order-loading-data/import-order-loading-data.component';
import { ImportOrderDocumentsComponent } from './import-order/import-order-documents/import-order-documents.component';
import { ImportOrderPaymentsComponent } from './import-order/import-order-payments/import-order-payments.component';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { OrderDetailTabComponent } from './order-detail-tab/order-detail-tab.component';
import { TabViewModule } from "primeng/tabview";
import { ExporterInfoModalComponent } from './exporter-info-modal/exporter-info-modal.component';
import { ProgramRequestDetailComponent } from './program-request/program-request-detail/program-request-detail.component';
import { UserImportOrderChatComponent } from './import-order/user-import-order-chat/user-import-order-chat.component';
import { FilterComponentComponent } from './filter-component/filter-component.component';
import { TagModule } from 'primeng/tag';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { DirectSaleDetailComponent } from "./direct-sale-detail/direct-sale-detail.component";
import { ImportProgramRequestListComponent } from './program-request/import-program-request-list/import-program-request-list.component';
import { PortNamePipe } from "src/app/pipes/port-name.pipe";
import { NotificationListComponent } from './notification-list/notification-list.component';
import { GalleriaModule } from 'primeng/galleria';
import { ProductCardComponent } from './product-card/product-card.component';
import { FooterHomeComponent } from './footer-home/footer-home.component';
import { SocialMediaShareComponent } from './social-media-share/social-media-share.component';
import { QrImageComponent } from './qr-image/qr-image.component';
import { ImageModule } from 'primeng/image';
import { RequestImportRequestComponent } from './request-import-request/request-import-request.component';
import { OverlayPanelModule } from "primeng/overlaypanel";
import { ImportRequestCarouselComponent } from './import-request-carousel/import-request-carousel.component';
import { TextPreviewComponent } from './text-preview/text-preview.component';
import { TextPreviewTooltipComponent } from './text-preview-tooltip/text-preview-tooltip.component';
import { ImportRequestCardComponent } from './import-request-card/import-request-card.component';
import { MaskPipe } from "src/app/pipes/mask.pipe";
import { ListDocumentsByTypeComponent } from './list-documents-by-type/list-documents-by-type.component';
import { AccordionModule } from "primeng/accordion";
import { SplineAreaChartComponent } from './charts/spline-area-chart/spline-area-chart.component';
import { NgApexchartsModule } from "ng-apexcharts";
import { InputSwitchModule } from 'primeng/inputswitch';
import { BadgeModule } from "primeng/badge";
import { TableRowCardComponent } from './user-load-orders-program/table-row-card/table-row-card.component';
import { UploadExportCertificatesComponent } from './upload-export-certificates/upload-export-certificates.component';
import { UploadExportDocumentsComponent } from './upload-export-documents/upload-export-documents.component';
import { CopyPasteExcelComponent } from './copy-paste-excel/copy-paste-excel.component';
import { DetailOrderCardComponent } from './detail-order-card/detail-order-card.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { UserPanelDetailComponent } from './user-panel-detail/user-panel-detail.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { BreadcrumbModule } from "primeng/breadcrumb";
import { PasswordModule } from "primeng/password";
import { ContactInfoComponent } from './contact-info/contact-info.component';
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { FileUploadCustomComponent } from './file-upload-custom/file-upload-custom.component';
import { FileDropDirective } from "./file-drop.directive";
import { TechnicalDocumentTypeNamePipe } from "src/app/pipes/technical-document-type-name.pipe";
import { DocumentTypeNamePipe } from "src/app/pipes/document-type-name.pipe";
import { SelectButtonDocumentsComponent } from './select-button-documents/select-button-documents.component';
import { SelectButtonModule } from "primeng/selectbutton";
import { ClosedSaleJoinRequestComponent } from './closed-sale-join-request/closed-sale-join-request.component';
import { BlockUIModule } from "primeng/blockui";
import { AssignStockComponent } from './assign-stock/assign-stock.component';
import { CreatePalletStockFormatComponent } from './create-pallet-stock-format/create-pallet-stock-format.component';
import { FilterPalletStockComponent } from './filter-pallet-stock/filter-pallet-stock.component';
import { MultiSelectModule } from "primeng/multiselect";
import { FormColdStorageComponent } from './form-cold-storage/form-cold-storage.component';
import { SpeciesListComponent } from './species-list/species-list.component';
import { ColdStoragesComponent } from './cold-storages/cold-storages.component';
import { FormManageSpeciesComponent } from './form-manage-species/form-manage-species.component';
import { SpeciesImageUrlPipe } from "src/app/pipes/species-image-url.pipe";
import { ProductCertificatesTabComponent } from './user-panel-detail/product-certificates-tab/product-certificates-tab.component';
import { ContactInfoTabComponent } from './user-panel-detail/contact-info-tab/contact-info-tab.component';
import { CompanyInfoTabComponent } from './user-panel-detail/company-info-tab/company-info-tab.component';
import { SecurityTabComponent } from './user-panel-detail/security-tab/security-tab.component';
import { PalletStockPreviewComponent } from './pallet-stock-preview/pallet-stock-preview.component';
import { StockColumnPipe } from "src/app/pipes/stock-column.pipe";
import { CheckboxModule } from 'primeng/checkbox';
import { ProgressBarModule } from 'primeng/progressbar';
import { StockColumnDescPipe } from "src/app/pipes/stock-column-desc.pipe";
import { ViewStockAlertsComponent } from './view-stock-alerts/view-stock-alerts.component';
import { TransportNamePipe } from "src/app/pipes/transport-name.pipe";
import { BoxesPerPalletFactorPipe } from "src/app/pipes/boxes-per-pallets-factor.pipe";
import { QuarterNameConfigFormComponent } from './quarter-name-config-form/quarter-name-config-form.component';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { StockStatsComponent } from './stock-stats/stock-stats.component';
import { StockColumnRuleComponent } from './stock-colum-rule/stock-column-rule.component';
import { DownloadedDocumentsTableComponent } from "./downloaded-documents-table/downloaded-documents-table.component";
import { PaginatorModule } from "primeng/paginator";
import { FlagDirective } from "./flag.directive";
import { ProgramFromStockFormComponent } from './program-from-stock-form/program-from-stock-form.component';
import { TransportTypeIconComponent } from './transport-type-icon/transport-type-icon.component';
import { LocationInfoComponent } from './location-info/location-info.component';
import { EditProgramFromStockComponent } from './edit-program-from-stock/edit-program-from-stock.component';
import { ImportProcessesTableComponent } from './import-processes-table/import-processes-table.component';
import { StocksTableComponent } from './stocks-table/stocks-table.component';
import { ProgramMassiveImportTableComponent } from './program-massive-import-table/program-massive-import-table.component';
import { PasswordCustomFieldComponent } from "./password-custom-field/password-custom-field.component";

@NgModule({
    declarations: [
        DashboardLayoutComponent,
        ContentBodyComponent,
        ContentHeaderComponent,
        HomeHeaderComponent,
        UserDashboardComponent,
        SideMenuComponent,
        UserMenuComponent,
        AdminDashboardComponent,
        ExportOfferDetailComponent,
        TimerComponent,
        WishListComponent,
        SwitchLangComponent,
        ImportRequestDetailComponent,
        ExportOfferDetailDescriptionComponent,
        ExportOfferDetailCarouselComponent,
        ImportOrderDeliveryComponent,
        ImportOrderOperationComponent,
        UserImportOrderListComponent,
        FrozenFruitExportOfferDetailComponent,
        FrozenFruitExportOfferDetailCarouselComponent,
        FrozenFruitExportOfferDetailDescriptionComponent,
        ExportOfferCreateOptionComponent,
        ExportOfferPictureUploaderComponent,
        ExportOfferCertificateTypeComponent,
        CountryDescriptionPipe,
        DocumentDescriptionPipe,
        ColorNamePipe,
        SpeciesNamePipe,
        SpeciesImageUrlPipe,
        FormErrorMessagePipe,
        DisclaimerComponent,
        RequestsCodeComponent,
        ImportOrderBillInfoComponent,
        ImportOrderLoadingDataComponent,
        ImportOrderDocumentsComponent,
        ImportOrderPaymentsComponent,
        OrderDetailTabComponent,
        ExporterInfoModalComponent,
        ProgramRequestDetailComponent,
        FilterComponentComponent,
        DirectSaleDetailComponent,
        ImportProgramRequestListComponent,
        UserImportOrderChatComponent,
        FilterComponentComponent,
        PortNamePipe,
        NotificationListComponent,
        ProductCardComponent,
        FooterHomeComponent,
        SocialMediaShareComponent,
        QrImageComponent,
        RequestImportRequestComponent,
        ImportRequestCarouselComponent,
        TextPreviewComponent,
        TextPreviewTooltipComponent,
        ImportRequestCardComponent,
        MaskPipe,
        ListDocumentsByTypeComponent,
        SplineAreaChartComponent,
        TableRowCardComponent,
        UploadExportCertificatesComponent,
        UploadExportDocumentsComponent,
        CopyPasteExcelComponent,
        DetailOrderCardComponent,
        SidebarComponent,
        UserPanelDetailComponent,
        ChangePasswordComponent,
        ContactInfoComponent,
        FileUploadCustomComponent,
        FileDropDirective,
        TechnicalDocumentTypeNamePipe,
        DocumentTypeNamePipe,
        SelectButtonDocumentsComponent,
        ClosedSaleJoinRequestComponent,
        AssignStockComponent,
        CreatePalletStockFormatComponent,
        FilterPalletStockComponent,
        FormColdStorageComponent,
        SpeciesListComponent,
        ColdStoragesComponent,
        FormManageSpeciesComponent,
        ProductCertificatesTabComponent,
        ContactInfoTabComponent,
        CompanyInfoTabComponent,
        SecurityTabComponent,
        PalletStockPreviewComponent,
        StockColumnPipe,
        StockColumnDescPipe,
        ViewStockAlertsComponent,
        TransportNamePipe,
        BoxesPerPalletFactorPipe,
        QuarterNameConfigFormComponent,
        StockStatsComponent,
        StockColumnRuleComponent,
        DownloadedDocumentsTableComponent,
        FlagDirective,
        ProgramFromStockFormComponent,
        TransportTypeIconComponent,
        LocationInfoComponent,
        EditProgramFromStockComponent,
        ProgramMassiveImportTableComponent,
        PasswordCustomFieldComponent,
        ImportProcessesTableComponent,
        StocksTableComponent
    ],
    exports: [
        DashboardLayoutComponent,
        ContentHeaderComponent,
        ContentBodyComponent,
        HomeHeaderComponent,
        UserDashboardComponent,
        AdminDashboardComponent,
        ExportOfferDetailComponent,
        TimerComponent,
        SwitchLangComponent,
        ImportRequestDetailComponent,
        ExportOfferDetailDescriptionComponent,
        ExportOfferDetailCarouselComponent,
        ImportOrderDeliveryComponent,
        ImportOrderOperationComponent,
        UserImportOrderListComponent,
        FrozenFruitExportOfferDetailComponent,
        ExportOfferPictureUploaderComponent,
        ExportOfferCertificateTypeComponent,
        ExportOfferCreateOptionComponent,
        CountryDescriptionPipe,
        DocumentDescriptionPipe,
        ColorNamePipe,
        SpeciesNamePipe,
        SpeciesImageUrlPipe,
        DisclaimerComponent,
        RequestsCodeComponent,
        FormErrorMessagePipe,
        ImportOrderBillInfoComponent,
        ImportOrderLoadingDataComponent,
        ImportOrderDocumentsComponent,
        ImportOrderPaymentsComponent,
        OrderDetailTabComponent,
        ExporterInfoModalComponent,
        ProgramRequestDetailComponent,
        FilterComponentComponent,
        DirectSaleDetailComponent,
        ImportProgramRequestListComponent,
        UserImportOrderChatComponent,
        FilterComponentComponent,
        PortNamePipe,
        ProductCardComponent,
        FooterHomeComponent,
        SocialMediaShareComponent,
        QrImageComponent,
        RequestImportRequestComponent,
        ImportRequestCarouselComponent,
        TextPreviewComponent,
        TextPreviewTooltipComponent,
        ImportRequestCardComponent,
        MaskPipe,
        ListDocumentsByTypeComponent,
        SplineAreaChartComponent,
        TableRowCardComponent,
        UploadExportCertificatesComponent,
        UploadExportDocumentsComponent,
        CopyPasteExcelComponent,
        DetailOrderCardComponent,
        FileUploadCustomComponent,
        TechnicalDocumentTypeNamePipe,
        DocumentTypeNamePipe,
        SelectButtonDocumentsComponent,
        UserPanelDetailComponent,
        ChangePasswordComponent,
        ContactInfoComponent,
        FileUploadCustomComponent,
        ClosedSaleJoinRequestComponent,
        AssignStockComponent,
        CreatePalletStockFormatComponent,
        FilterPalletStockComponent,
        FormColdStorageComponent,
        SpeciesListComponent,
        ColdStoragesComponent,
        FormManageSpeciesComponent,
        ProductCertificatesTabComponent,
        ContactInfoTabComponent,
        CompanyInfoTabComponent,
        SecurityTabComponent,
        StockColumnPipe,
        StockColumnDescPipe,
        TransportNamePipe,
        BoxesPerPalletFactorPipe,
        QuarterNameConfigFormComponent,
        StockStatsComponent,
        StockColumnRuleComponent,
        DownloadedDocumentsTableComponent,
        FlagDirective,
        ProgramFromStockFormComponent,
        TransportTypeIconComponent,
        LocationInfoComponent,
        ProgramMassiveImportTableComponent,
        PasswordCustomFieldComponent,
        ImportProcessesTableComponent,
        StocksTableComponent
    ],
    bootstrap: [DashboardLayoutComponent],
    imports: [
        ReactiveFormsModule,
        FormsModule,
        CommonModule,
        RouterModule,
        MenubarModule,
        PanelMenuModule,
        CardModule,
        PanelModule,
        DynamicDialogModule,
        MenuModule,
        SidebarModule,
        ButtonModule,
        TabMenuModule,
        DividerModule,
        InputTextModule,
        InputNumberModule,
        MessagesModule,
        MessageModule,
        CarouselModule,
        CalendarModule,
        DropdownModule,
        TableModule,
        FileUploadModule,
        ColorPickerModule,
        DataViewModule,
        InputMaskModule,
        FontAwesomeModule,
        TabViewModule,
        TagModule,
        ToggleButtonModule,
        ImageModule,
        OverlayPanelModule,
        PaginatorModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpTranslateLoader,
                deps: [HttpClient]
            }
        }),
        DialogModule,
        GalleriaModule,
        AccordionModule,
        NgApexchartsModule,
        InputSwitchModule,
        BadgeModule,
        SelectButtonModule,
        BreadcrumbModule,
        PasswordModule,
        ConfirmDialogModule,
        BlockUIModule,
        MultiSelectModule,
        CheckboxModule,
        ProgressBarModule,
        ToastModule
    ]
})
export class ComponentsModule{

}

// AOT compilation support
export function httpTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http);
  }
